var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPressure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 17.2501V15.1032C2.25 9.71257 6.58125 5.26882 11.9625 5.25007C13.246 5.24514 14.5179 5.49368 15.7052 5.98146C16.8924 6.46923 17.9717 7.18663 18.881 8.09249C19.7904 8.99835 20.5119 10.0749 21.0043 11.2602C21.4966 12.4456 21.75 13.7165 21.75 15.0001V17.2501C21.75 17.449 21.671 17.6397 21.5303 17.7804C21.3897 17.9211 21.1989 18.0001 21 18.0001H3C2.80109 18.0001 2.61032 17.9211 2.46967 17.7804C2.32902 17.6397 2.25 17.449 2.25 17.2501Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.25V8.25",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57812 12.4785L5.48438 13.2566",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4219 12.4785L18.5156 13.2566",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69336 17.9996L16.1059 9.64648",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressure);
export default __webpack_public_path__ + "static/media/pressure.a38ee29c8ddcb80ce3abd17741067993.svg";
export { ForwardRef as ReactComponent };